/* customGroup/reducer */

import { createReducer } from "typesafe-actions";
import { CustomGroupActionTypes, CustomGroupState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchError,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError,
} from "./actions";

export const initialState: CustomGroupState = {
  data: undefined,
  errors: undefined,
  loading: false,
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>
  | ReturnType<typeof deleteRequest>
  | ReturnType<typeof deleteSuccess>
  | ReturnType<typeof deleteError>;

export default createReducer<CustomGroupState, ActionType>(initialState)
  .handleType(CustomGroupActionTypes.FETCH, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(CustomGroupActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(CustomGroupActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload,
    };
  })
  .handleType(CustomGroupActionTypes.SAVE_REQUEST, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(CustomGroupActionTypes.SAVE_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(CustomGroupActionTypes.SAVE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
      // data: undefined
    };
  })
  .handleType(CustomGroupActionTypes.DELETE_REQUEST, (state) => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(CustomGroupActionTypes.DELETE_SUCCESS, (state) => {
    return {
      ...state,
      loading: false,
      errors: undefined,
    };
  })
  .handleType(CustomGroupActionTypes.DELETE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  });
